// Base
import Image from 'next/image'

// Packages
import htmr from 'htmr'

// Components
import { Box, Container, Flex, Text } from 'yard-utilities/components'

// Assets
import TravelersImage from '@images/v21/photos/travelers.png'
import FullRefundImage from '@images/v21/photos/full-refund.png'

// Styles
import styles from './FullRefundText.module.sass'

const FullRefundText = () => {
  return (
    <section className={styles.section}>
      <Container>
        <Box
          backgroundColor="white"
          borderRadius={{ sm: [16] }}
          overflow="hidden"
        >
          <Box padding={{ sm: [24, 16] }}>
            <Flex flexDirection="column" rowGap={{ sm: 24 }}>
              <Text tagName="h3" variant="title-5" align="center">
                Disfruta de un reembolso completo si reservas tu primer vuelo
                después de suscribirte
              </Text>

              <div className={styles.image}>
                <Image
                  src={TravelersImage}
                  fill
                  sizes="(max-width: 768px) 600px, (max-width: 1200px) 800px, 800px"
                  alt="Happy travelers"
                />

                <Image
                  src={FullRefundImage}
                  width={163}
                  height={130}
                  alt="Full Refund image"
                  sizes="250px"
                  style={{ minWidth: '163px' }}
                  className={styles.banner}
                />
              </div>

              <Description
                heading="Reserva un viaje con nosotros y te reembolsaremos el pago de la suscripción"
                description="Estamos seguros de que ahorrarás dinero en tus viajes con RatePunk, y queremos facilitar tu decisión. Suscríbete a RatePunk, reserva tu primer vuelo a través de nuestro servicio y obtén un reembolso completo del pago de tu suscripción."
              />

              <Description
                heading="¿Por qué ofrecemos esto?"
                description="Creemos en el valor de RatePunk y queremos que pruebes nuestro servicio sin riesgos. ¡Experimenta el ahorro y la comodidad, sabiendo que puedes recuperar tu dinero si reservas un vuelo!"
              />
            </Flex>
          </Box>

          <Box backgroundColor="yellow-10" padding={{ sm: [24, 16] }}>
            <Description
              heading="¿Cómo funciona?"
              description="Envíanos una prueba de la reserva y te reembolsaremos el importe total de tu suscripción."
            />
          </Box>
        </Box>
      </Container>
    </section>
  )
}

interface DescriptionProps {
  heading: string
  description: string
}

const Description = ({ heading, description }: DescriptionProps) => {
  return (
    <Flex flexDirection="column" rowGap={{ sm: 16 }}>
      <Text variant="title-3">{heading}</Text>
      <Text variant="body-1">{htmr(description)}</Text>
    </Flex>
  )
}

export default FullRefundText
